'use client';

import Link from 'next/link';
import ProposalCards from './ProposalCards';
import { useAtom, useAtomValue } from 'jotai';
import {
  initialProposalsAtom,
  allProposalsAtom,
  proposalCountAtom,
  proposalsLoadingAtom,
} from '@/app/atoms/proposals';
import { useEffect } from 'react';

const Proposals: React.FC = () => {
  const initialProposals = useAtomValue(initialProposalsAtom);
  const allProposals = useAtomValue(allProposalsAtom);
  const proposalCount = useAtomValue(proposalCountAtom);
  const [, setProposalsLoading] = useAtom(proposalsLoadingAtom);

  useEffect(() => {
    if (initialProposals.length > 0) {
      setProposalsLoading(false);
    }
    /* eslint-disable-next-line */
  }, [initialProposals]);

  return (
    <div className="flex flex-col justify-between mt-8 max-sm:text-center xs:rounded-md border border-neutral-700">
      <div className="flex flex-col items-start sm:items-center sm:justify-between sm:flex-row p-4 border-b border-neutral-700 gap-2">
        <div className="font-bold text-yellow">Proposals</div>
        <div className="flex max-sm:justify-center max-sm:hidden">
          <div className="mr-4 text-accent">
            <span className="mr-1 text-neutral-900 font-semibold rounded-full bg-accent w-4 h-4 px-1">
              {proposalCount.passed}
            </span>
            Passed
          </div>
          <div className="text-defeated">
            <span className="mr-1 px-1 text-neutral-900 font-semibold rounded-full bg-defeated">
              {proposalCount.failed}
            </span>
            Failed
          </div>
        </div>
      </div>
      <div className="flex flex-col p-4 max-w-full border-b border-neutral-700">
        <div className="flex flex-col items-start sm:items-center sm:justify-between sm:flex-row">
          <div className="whitespace-nowrap sm:w-3/5 text-xxs opacity-0">Proposal</div>
          <div className="flex w-2/5 justify-between max-sm:hidden text-xs">
            <div className="whitespace-nowrap text-center w-1/3">Votes for</div>
            <div className="whitespace-nowrap text-center w-1/3">Votes against</div>
            <div className="whitespace-nowrap text-right w-1/3">Total Voters</div>
          </div>
        </div>
      </div>
      <div className="divide-y divide-neutral-700">
        {initialProposals.map((proposal, index) => (
          <ProposalCards
            key={index}
            proposal={proposal}
            index={allProposals.length - index}
          />
        ))}
      </div>
      {allProposals.length > 0 && (
        <div className="flex justify-center py-8 border-t border-neutral-700">
          <Link href="/karratco/view/proposals">
            <div className="font-bold mx-auto cursor-pointer">View All</div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Proposals;
